import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MainMenuComponent } from '../../shared/main-menu/main-menu.component';
import { SubscribeComponent } from '../../shared/subscribe/subscribe.component';
import { ScriptLoaderService, VENDOR_SCRIPTS } from '../../script-loader.service';
@Component({
  selector: 'app-gallery',
  standalone: true,
  imports: [CommonModule, MainMenuComponent, SubscribeComponent],
  templateUrl: '../templates/gallery.component.html'
})
export class GalleryComponent implements AfterViewInit, OnDestroy {
  constructor(private readonly scriptLoader: ScriptLoaderService) { }

  ngAfterViewInit(): void {
    document.body.classList.add('defult-home');
    this.scriptLoader
      .loadSequential(...VENDOR_SCRIPTS)
      .then(() => {
        // If vendor scripts were injected after the native load event,
        // re-dispatch it so jQuery load handlers in main.js still run.
        if (document.readyState === 'complete') {
          window.dispatchEvent(new Event('load'));
        }
      })
      .catch((error) => {
        console.error('Failed to load third-party scripts', error);
      });
  }

  ngOnDestroy(): void {
    document.body.classList.remove('defult-home');
  }
}

